import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';
import { WhatsAppTemplateResponse } from '@/client/types/whatsapp/templates';

type QueryResponse = WhatsAppTemplateResponse;

export const createListTemplatesKey = (additional: any[] = []) => [
  'list-templates',
  ...additional,
];

export const useListTemplatesQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Templates',
    endpoint: `/api/admin/whatsapp/templates`,
  });

  return useQuery({
    queryKey: createListTemplatesKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};